<template>
  <section class="mb-30 lg:mb-80">
    <div class="container">

      <h1 class="font-bold text-center text-xl lg:text-2xl mb-25 leading-24 lg:leading-28">Configurateur Open</h1>

      <ol class="stepper">

        <li class="step isActive" aria-current="step">
          <a href="#">
            <span class="outerNbr"><span class="nbr">1</span></span>
            <span class="txt">Mobile</span>
          </a>
        </li>
        <li class="step">
          <a href="#">
            <span class="outerNbr"><span class="nbr">2</span></span>
            <span class="txt">Forfait mobile</span>
          </a>
        </li>
        <li class="step">
          <a href="#">
            <span class="outerNbr"><span class="nbr">3</span></span>
            <span class="txt">Connexion</span>
          </a>
        </li>
        <li class="step">
          <a href="#">
            <span class="outerNbr"><span class="nbr">4</span></span>
            <span class="txt">Offre Internet</span>
          </a>
        </li>
        <li class="step">
          <a href="#">
            <span class="outerNbr"><span class="nbr"><span class="block w-14 lg:w-24 h-14 lg:h-24 c-grey11"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 20"><path fill="currentColor" fill-rule="evenodd" d="m24.9063 3.3549-13.6551 15.75-.0004-.0002c-.391.4503-.9917.7391-1.6657.7391-.674 0-1.2747-.2888-1.6657-.7391l-.0004.0002-6.8275-7.875.0003-.0003C.7993 10.8926.6239 10.4654.6239 10c0-.5437.2388-1.0358.6249-1.3921l.8535-.7875c.386-.3563.9195-.5766 1.5087-.5766.5302 0 1.015.1789 1.3882.4743l.0003-.0004 4.1589 4.2511L21.781.6888l.0004.0003c.3815-.3303.8944-.5329 1.4588-.5329 1.1784 0 2.1337.8815 2.1337 1.9688 0 .4653-.1754.8926-.4679 1.2296l.0003.0003Z" clip-rule="evenodd"/></svg></span></span></span>
            <span class="txt">Terminé !</span>
          </a>
        </li>

      </ol>
    </div>
  </section>

  <section class="mb-50 lg:mb-110">
    <div class="container">

      <div class="max-w-300 lg:max-w-0 mx-auto">
        <h2 v-if="data_etape0.field_etape1_titre" class="font-bold lg:text-xl text-center leading-22 lg:leading-24 mb-10 lg:mb-20">{{ data_etape0.field_etape1_titre }}</h2>
        <p v-if="data_etape0.field_etape1_sous_titre" class="text-center mb-35 lg:mb-50">{{ data_etape0.field_etape1_sous_titre }}</p>
      </div>

      <div class="dflex justify-center gap-15 lg:gap-30" id="choixMobile">
        <button @click="loadNext();taggage('configurateur_open', 'mobile_tarif_exclusif', 'non', { tealium_event: 'select_content' })" type="button" class="btn btn--md btn--fill-light w-full max-w-170">Non</button>
        <button @click="loadMobile();taggage('configurateur_open', 'mobile_tarif_exclusif', 'oui', { tealium_event: 'select_content' })" type="button" class="btn btn--md btn--fill-dark w-full max-w-170">Oui</button>
      </div>
    </div>

    <component :is="mobileComponent" :parcours="parcours" :tag="tag" :recapKey="recapKey" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape2="$emit('switchToEtape2')" @incrementRecapKey="recapKey++" />

  </section>

  <component :is="recapComponent" :key="recapKey" :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId" @switchToEtape1="$emit('switchToEtape1')" @switchToEtape2="$emit('switchToEtape2')" @switchToEtape3="$emit('switchToEtape3')" @switchToEtape4="$emit('switchToEtape4')" @switchToEtape5="$emit('switchToEtape5')" />


</template>

<script setup>
import { ref } from 'vue';
import { onMounted } from 'vue';
import Etape1Mobile from './Etape1Mobile.vue';
import Etape5Recap from './Etape5Recap.vue';
import { taggage, taggageView, resetTag } from '@/utils/taggage.js';
import { globalStore } from '@/utils/store.js';

globalStore.tag.tealium_event = "product_click";

const data_etape1 = ref({});
const error_etape1 = ref(null);
const error_etape2 = ref(null);

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  tag: Object
});


//defineEmits(['switchToEtape2']);

const mobileComponent = ref(null);
const recapKey = ref(0);

//const emit = defineEmits(['switchToEtape2']);
const emit = defineEmits(['switchToEtape1','switchToEtape2','switchToEtape3','switchToEtape4','switchToEtape5']);

const recapComponent = ref(null);
recapComponent.value = Etape5Recap;

const loadMobile = () => {

  if (props.parcours.mobile == 0) {
    props.parcours.forfait = 0;
    props.parcours.multiligne = 0;
    props.parcours.connexion = 0;
    props.parcours.livebox = 0;
    props.parcours.multilignes.multiligne1.forfait = 0;
    props.parcours.multilignes.multiligne2.forfait = 0;
    props.parcours.multilignes.multiligne3.forfait = 0;
    props.parcours.multilignes.multiligne4.forfait = 0;
    props.parcours.multilignes.multiligne1.who = 0;
    props.parcours.multilignes.multiligne2.who = 0;
    props.parcours.multilignes.multiligne3.who = 0;
    props.parcours.multilignes.multiligne4.who = 0;
  }

  document.getElementById('choixMobile').style.display = "none";
  mobileComponent.value = Etape1Mobile;

};

const loadNext = () => {
  if (props.parcours.mobile == 1) {
    props.parcours.forfait = 0;
    props.parcours.multiligne = 0;
    props.parcours.connexion = 0;
    props.parcours.livebox = 0;
    props.parcours.multilignes.multiligne1.forfait = 0;
    props.parcours.multilignes.multiligne2.forfait = 0;
    props.parcours.multilignes.multiligne3.forfait = 0;
    props.parcours.multilignes.multiligne4.forfait = 0;
    props.parcours.multilignes.multiligne1.who = 0;
    props.parcours.multilignes.multiligne2.who = 0;
    props.parcours.multilignes.multiligne3.who = 0;
    props.parcours.multilignes.multiligne4.who = 0;
  }
  emit('switchToEtape2');
};

onMounted(async () => {
  try {
    //console.log('Etape1Inner mounted');
    props.parcours.etape = 1;
    resetTag(1);
    taggage('configurateur_open', 'etape_1', 'display', { tealium_event: 'select_content'});
    //taggageView('XXXX', 'Orange', 'XXXX', 'portail', 'RES', 'global', 'XXXX', 'configurateur_etape_1', 'XXXX', 'Pack Open', 'internet', 'XXXX');
    //taggageView('mobile web', 'Orange', '', 'portail', 'RES', 'global', 'configurateur_etape_1', 'Pack Open', 'internet', window.devicePixelRatio);
    taggageView('mobile web', 'Orange', '', 'portail', 'RES', 'global', 'configurateur_etape_1', 'Pack Open', 'internet', window.devicePixelRatio);
    if (props.parcours.mobile != 0) {
      loadMobile();
    }
  } catch (e) {
    error_etape1.value = e.message;
  }
});
//taggage(track_zone, track_nom, track_cible, options = {}) {

</script>
